import React, { type CSSProperties, type Ref } from "react";

import DiscoverRowArrow from "@/pages/Discover/components/DiscoverRowArrow";
import { cn } from "@/utils";

type DiscoverRowTrackProps = {
  refTrack: Ref<HTMLDivElement | null>;
  trackStyle: CSSProperties;
  canScrollPrevious: boolean;
  canScrollNext: boolean;
  onScrollPrevious: () => void;
  onScrollNext: () => void;
  previousLabel: string;
  nextLabel: string;
  children: React.ReactNode;
  shouldUseTwoRows: boolean;
};

const DiscoverRowTrack = ({
  refTrack,
  trackStyle,

  canScrollPrevious,
  canScrollNext,
  onScrollPrevious,
  onScrollNext,
  previousLabel,
  nextLabel,
  children,
  shouldUseTwoRows,
}: DiscoverRowTrackProps) => {
  return (
    <div data-testid="DiscoverRowTrack" className="relative">
      <div
        ref={refTrack}
        data-testid="DiscoverRowTrack-ScrollArea"
        className={cn(
          "grid grid-flow-col items-start overflow-x-auto [scrollbar-width:none] [ms-overflow-style:none] [&::-webkit-scrollbar]:hidden",
          shouldUseTwoRows ? "grid-rows-2" : "grid-rows-1",
        )}
        style={trackStyle}
      >
        {children}
      </div>
      {canScrollPrevious ? <DiscoverRowArrow isNext={false} label={previousLabel} onClick={onScrollPrevious} /> : null}
      {canScrollNext ? <DiscoverRowArrow isNext={true} label={nextLabel} onClick={onScrollNext} /> : null}
    </div>
  );
};

export default React.memo(DiscoverRowTrack);
